import { useDispatch, useSelector } from 'react-redux'
import { LOGOUT, USUER } from '../../constants/api'
import { actionLogoutUser, actionUpdateUser } from '../../redux/actions/user'
import useMutation from '../useMutation'

export const useUser = () => {
  const [handleGetUser] = useMutation(USUER, false)
  const [handleLogoutUser] = useMutation(LOGOUT, true)
  const dispatch = useDispatch()
  const { user } = useSelector(state => state.userReducer)

  /**
   * get info user
   *
   *
   * @author   ehernandez
   * @param    {Boolean}   updateStorage   update redux storage

   */
  const handleUser = async (updateStorage = true) => {
    const { success, data } = await handleGetUser({ method: 'get' })
    if (!success) {
      return null
    }
    if (updateStorage) {
      handleGetUser({ method: 'get' })
      dispatch(actionUpdateUser(data))
    }
  }

  /**
   * Logout user event
   * remove token and redirect to login
   *
   *
   * @author   ehernandez
   * @param    {Boolean}   updateStorage   update redux storage

   */
  const logoutUser = () => {
    handleLogoutUser({ method: 'get' })
    dispatch(actionLogoutUser())
  }

  return { handleUser, logoutUser, user }
}
